import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import PortfolioDetailsMain from './PortfolioDetailsMain';
import Footer from '../../components/Footer';

const PortfolioDetails = () => {
  return (
    <>
      <HeaderSeven />

      <PortfolioDetailsMain />

      <Footer />
    </>
  );
};

export default PortfolioDetails;
